<template>
  <div class="mianshaItem">
    <div class="head_img" :style="head_img_style"  @click.prevent="click_img">
      <div class="vip_tag">
        <LevelTag :level="info.growth_level" />
      </div>
    </div>
    <!-- <img :src="info.head_img" class="head_img" @click.prevent="click_img" /> -->
    <div class="infos">
      <div class="title" @click.prevent="click_img">{{this.info.award_name}}</div>
      <div class="current_price" @click.prevent="click_img">
        <div style="font-size:.3rem;margin-top:-0.07rem">{{this.info.current_price}}</div>元秒杀
      </div>
      <div class="other_info">
        <div v-if="this.info.origin_price >= 0" class="origin_price" @click.prevent="click_img">原价￥{{this.info.origin_price}}元</div>
        <div class="remain">
          共
          <div style="color:#FF5C04">{{info.award_num}}</div>份
        </div>
      </div>
    </div>

    <div v-if="info.received === 1" class="button" @click="click_button">已抢到</div>
    <div v-else-if="info.made_appointment === 0" class="button" @click="click_button">
      <img class="yuyue_icon" src="../../../../static/yuyue_icon.svg" />
      预约
    </div>
    <div v-else-if="info.made_appointment === 1" class="button">已预约</div>
    <div v-else-if="info.out_stock === 1" class="button disbale_button" @click="click_button">已抢光</div>
    <div v-else-if="info.end === 1" class="button disbale_button" @click="click_button">已结束</div>
    <div v-else class="button" @click="click_button">立即抢</div>
  </div>
</template>
<script>
import { openLink } from "../../../tools/mgtv/link";
import click_handler from "../../../tools/mgtv/click";
import LevelTag from "../LevelTag.vue";

export default {
  name: "WelfareItem",
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          award_id: 522,
          award_name: "我是标题",
          award_num: 10,
          head_img: "https://via.placeholder.com/64x32?text=ICON",
          pos: 1,
          growth_level: 1,
          info: "",
          note: "2019-09-18",
          sub_title: "副标题",
          origin_price: "200",
          current_price: "0",
          made_appointment: 0
        };
      }
    },
    click_button: {
      type: Function,
      default: () => {
        console.log("点击按钮");
      }
    },
    click_img: {
      type: Function,
      default: () => {
        console.log("点击封面");
      }
    }
  },
  components: { LevelTag },
  data: function() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {
    head_img_style: function() {
      return {
        background: `url(${this.info.head_img}) 0% 0% / 100% 100% no-repeat`
      };
    }
  }
};
</script>


<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
.mianshaItem
    position relative
    display  block
    margin-top .2rem
    padding .25rem .15rem
    width:7.1rem;
    background:white;
    box-shadow:0px 0.03rem 0.08rem 0.02rem rgba(0,0,0,0.06);  
    display flex 
    align-items center
    .head_img
        position relative
        width 1.6rem
        height 1.3rem
    .vip_tag
       position absolute
       bottom 0.06rem
       right .06rem    
    .infos
        position relative
        display flex
        flex-direction column
        justify-content space-between
        height 1.2rem
        padding-left .2rem
        .title
          font-size .28rem
          color #333333
        .current_price
          color #EA9C07
          font-size .2rem  
          display flex 
        .other_info
          display flex
          align-items center
          .origin_price
              color #969696
              font-size .2rem
              text-decoration line-through
              margin-right .2rem
          .remain
              color #969696
              font-size .2rem
              display flex 
              >div
                font-size .2rem
      .button
        position absolute
        bottom .36rem
        right .2rem
        width:1.2rem;
        height:.48rem;
        background:rgba(255,95,0,0.15);
        border-radius:.27rem;   
        color #FF5C04
        text-align center
        line-height @height
        font-size .22rem
        display flex
        justify-content center
        align-items center
        .yuyue_icon
            display block
            height .3rem
            margin-right .05rem
    .disbale_button
        filter: grayscale(100%);


              
</style>
